import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

export const customStyles = {
  heading: { color: "inherit" },
  paragraph: { color: "inherit", fontSize: "md", display: "inline" },
  list: { color: "inherit", listStylePosition: "inside", mb: 4, fontSize: "md" },
} as RichtextAdapterProps["customStyles"];
